// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EvaluationSummaryModal .Modal-Dialog .Modal-Content {
  max-height: 90vh;
}
.EvaluationSummaryModal .Modal-Dialog .Modal-Body {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  flex: 1 1 auto;
  min-height: 0;
}
.EvaluationSummaryModal-Error {
  padding-top: 3rem;
}
.EvaluationSummaryModal-ErrorAlert {
  text-align: center;
}
.EvaluationSummaryModal-ErrorAlert small {
  display: block;
  margin-top: 0.75rem;
}
.EvaluationSummaryModal-Body {
  overflow-y: auto;
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding-right: 0.5rem;
}
.EvaluationSummaryModal-Footer {
  flex: 0 0 auto;
  display: flex;
  justify-content: flex-end;
  padding-top: 0.75rem;
  margin-top: 0.75rem;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}
.EvaluationSummaryModal-Section {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
.EvaluationSummaryModal-Section > h5 {
  margin: 0;
}
.EvaluationSummaryModal-SectionHeader {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
.EvaluationSummaryModal-SectionHeader h5,
.EvaluationSummaryModal-SectionHeader p {
  margin: 0;
}
.EvaluationSummaryModal-SectionIcon {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.75rem;
  font-size: 1.5rem;
  padding: 0.75rem;
}
.EvaluationSummaryModal-SectionIcon-Notes {
  background-color: #f3e8ff;
}
.EvaluationSummaryModal-SectionIcon-Eval {
  background-color: #e0e7ff;
}
.EvaluationSummaryModal-Label {
  margin: 0;
  color: var(--bs-primary);
  letter-spacing: 0.06em;
  font-weight: 700;
  text-transform: uppercase;
}
.EvaluationSummaryModal-HelperText {
  margin: 0;
}
.EvaluationSummaryModal-Notes {
  resize: none;
}
.EvaluationSummaryModal-Summary {
  background-color: #f9fafc;
  border-radius: 4px;
  padding: 1rem 1.25rem;
}
.EvaluationSummaryModal-Summary > .EvaluationSummaryModal-Label {
  margin-bottom: 0.75rem;
}
.EvaluationSummaryModal-Summary-Row {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem 2rem;
  margin-bottom: 0.5rem;
}
.EvaluationSummaryModal-Summary-Row:last-child {
  margin-bottom: 0;
}
.EvaluationSummaryModal-Summary-Row strong {
  color: var(--bs-primary);
  font-weight: 600;
}
.EvaluationSummaryModal-Summary-Key {
  color: #808080;
  margin-right: 0.5rem;
}
.EvaluationSummaryModal-Category {
  margin-bottom: 1.5rem;
}
.EvaluationSummaryModal-CategoryHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}
.EvaluationSummaryModal-CategoryHeader h5 {
  margin: 0;
}
.EvaluationSummaryModal-CategoryCount {
  margin: 0;
  color: var(--bs-secondary-color);
}
.EvaluationSummaryModal-CategoryPercent {
  font-weight: 700;
  font-size: 1.25rem;
}
.EvaluationSummaryModal-ResultPills {
  display: flex;
  flex-direction: row;
  gap: 0.75rem;
  margin: 0;
}
.EvaluationSummaryModal-ResultPill {
  width: auto;
  flex: 1 1 0;
  border-radius: var(--bs-border-radius-pill);
  font-weight: 700;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.1), 4px 6px 6px 0 rgba(0, 0, 0, 0.06);
}
.EvaluationSummaryModal-ResultPill.disabled, .EvaluationSummaryModal-ResultPill:disabled {
  opacity: 1;
}
.EvaluationSummaryModal-ResultPill-Checked {
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25) inset;
}`, "",{"version":3,"sources":["webpack://./src/pages/Reports/DynamicReport/components/EvaluationSummaryModal/styles.scss"],"names":[],"mappings":"AAEI;EACE,gBAAA;AADN;AAGI;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;AADN;AAKE;EACE,iBAAA;AAHJ;AAME;EACE,kBAAA;AAJJ;AAMI;EACE,cAAA;EACA,mBAAA;AAJN;AAQE;EACE,gBAAA;EACA,cAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,qBAAA;AANJ;AASE;EACE,cAAA;EACA,aAAA;EACA,yBAAA;EACA,oBAAA;EACA,mBAAA;EACA,wCAAA;AAPJ;AAUE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AARJ;AAUI;EACE,SAAA;AARN;AAYE;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AAVJ;AAYI;;EAEE,SAAA;AAVN;AAcE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;AAZJ;AAcI;EACE,yBAAA;AAZN;AAeI;EACE,yBAAA;AAbN;AAiBE;EACE,SAAA;EACA,wBAAA;EACA,sBAAA;EACA,gBAAA;EACA,yBAAA;AAfJ;AAkBE;EACE,SAAA;AAhBJ;AAmBE;EACE,YAAA;AAjBJ;AAoBE;EACE,yBAAA;EACA,kBAAA;EACA,qBAAA;AAlBJ;AAoBI;EACE,sBAAA;AAlBN;AAqBI;EACE,aAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;AAnBN;AAqBM;EACE,gBAAA;AAnBR;AAsBM;EACE,wBAAA;EACA,gBAAA;AApBR;AAwBI;EACE,cAAA;EACA,oBAAA;AAtBN;AA0BE;EACE,qBAAA;AAxBJ;AA2BE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAzBJ;AA2BI;EACE,SAAA;AAzBN;AA6BE;EACE,SAAA;EACA,gCAAA;AA3BJ;AA8BE;EACE,gBAAA;EACA,kBAAA;AA5BJ;AAiCE;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,SAAA;AA/BJ;AAkCE;EACE,WAAA;EACA,WAAA;EACA,2CAAA;EACA,gBAAA;EACA,6EACE;AAjCN;AAoCI;EAEE,UAAA;AAnCN;AAsCI;EACE,iDAAA;AApCN","sourcesContent":[".EvaluationSummaryModal {\n  .Modal-Dialog {\n    .Modal-Content {\n      max-height: 90vh;\n    }\n    .Modal-Body {\n      display: flex;\n      flex-direction: column;\n      overflow: hidden;\n      flex: 1 1 auto;\n      min-height: 0;\n    }\n  }\n\n  &-Error {\n    padding-top: 3rem;\n  }\n\n  &-ErrorAlert {\n    text-align: center;\n\n    small {\n      display: block;\n      margin-top: 0.75rem;\n    }\n  }\n\n  &-Body {\n    overflow-y: auto;\n    flex: 1 1 auto;\n    min-height: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n    padding-right: 0.5rem;\n  }\n\n  &-Footer {\n    flex: 0 0 auto;\n    display: flex;\n    justify-content: flex-end;\n    padding-top: 0.75rem;\n    margin-top: 0.75rem;\n    border-top: 1px solid rgba(0, 0, 0, 0.1);\n  }\n\n  &-Section {\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n\n    > h5 {\n      margin: 0;\n    }\n  }\n\n  &-SectionHeader {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n\n    h5,\n    p {\n      margin: 0;\n    }\n  }\n\n  &-SectionIcon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 0.75rem;\n    font-size: 1.5rem;\n    padding: 0.75rem;\n\n    &-Notes {\n      background-color: #f3e8ff;\n    }\n\n    &-Eval {\n      background-color: #e0e7ff;\n    }\n  }\n\n  &-Label {\n    margin: 0;\n    color: var(--bs-primary);\n    letter-spacing: 0.06em;\n    font-weight: 700;\n    text-transform: uppercase;\n  }\n\n  &-HelperText {\n    margin: 0;\n  }\n\n  &-Notes {\n    resize: none;\n  }\n\n  &-Summary {\n    background-color: #f9fafc;\n    border-radius: 4px;\n    padding: 1rem 1.25rem;\n\n    > .EvaluationSummaryModal-Label {\n      margin-bottom: 0.75rem;\n    }\n\n    &-Row {\n      display: flex;\n      flex-wrap: wrap;\n      gap: 0.5rem 2rem;\n      margin-bottom: 0.5rem;\n\n      &:last-child {\n        margin-bottom: 0;\n      }\n\n      strong {\n        color: var(--bs-primary);\n        font-weight: 600;\n      }\n    }\n\n    &-Key {\n      color: #808080;\n      margin-right: 0.5rem;\n    }\n  }\n\n  &-Category {\n    margin-bottom: 1.5rem;\n  }\n\n  &-CategoryHeader {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 1rem;\n\n    h5 {\n      margin: 0;\n    }\n  }\n\n  &-CategoryCount {\n    margin: 0;\n    color: var(--bs-secondary-color);\n  }\n\n  &-CategoryPercent {\n    font-weight: 700;\n    font-size: 1.25rem;\n  }\n\n  // Read-only mirror of CompleteEvaluationWizard's OverallResultPills (which are scoped to that\n  // component's stylesheet).\n  &-ResultPills {\n    display: flex;\n    flex-direction: row;\n    gap: 0.75rem;\n    margin: 0;\n  }\n\n  &-ResultPill {\n    width: auto;\n    flex: 1 1 0;\n    border-radius: var(--bs-border-radius-pill);\n    font-weight: 700;\n    box-shadow:\n      0 4px 4px 0 rgba(0, 0, 0, 0.1),\n      4px 6px 6px 0 rgba(0, 0, 0, 0.06);\n\n    &.disabled,\n    &:disabled {\n      opacity: 1;\n    }\n\n    &-Checked {\n      box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25) inset;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
